// src/components/skeleton/MerchantStoreSkeleton.js

import React from 'react';
import './MerchantStoreSkeleton.css';

function MerchantStoreSkeleton() {
  return (
    <div className="merchantstore-skeleton">
      <div className="merchantstore-banner-skeleton" />

      <div className="merchantstore-header-skeleton">
        <div className="merchantstore-logo-skeleton" />
        <div className="merchantstore-info-skeleton">
          <div className="merchantstore-name-skeleton" />
          <div className="merchantstore-location-skeleton" />
        </div>
      </div>

      <div className="merchantstore-grid-skeleton">
        {Array.from({ length: 6 }).map((_, idx) => (
          <div key={idx} className="merchantstore-product-skeleton">
            <div className="product-image-skeleton" />
            <div className="product-name-skeleton" />
            <div className="product-price-skeleton" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default MerchantStoreSkeleton;
